// extracted by mini-css-extract-plugin
export default {"cls1":"VeloActionBar-Icon_cls1__7yVDX","cls2":"VeloActionBar-Icon_cls2__z5zQY VeloActionBar-Icon_cls1__7yVDX"};